<template>
    <section class="content">
        <div class="container-fluid">
            <div class="row" v-show="!hasCertificate">
                <div class="col-md-12">
                    <div class="alert alert-warning">
                        <div class="row">
                            <div class="col-md-3">
                                <p>
                                    {{ $t('residence_certificate_upload_note') }}
                                </p>
                            </div>
                            <div class="col-md-3 ">
                                <VueFileAgent
                                    :multiple="false"
                                    :maxSize="'10MB'"
                                    :compact="true"
                                    :uploadUrl="residenceCertificateUploadUrl"
                                    :uploadHeaders="$axios.defaults.headers.common"
                                    maxFiles="1"
                                    @upload="onUploadResidenceCertificate"
                                    :helpText="$t('drag_and_drop')"
                                    thumbnailSize="20"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">

                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">{{ $t('movies_reports') }}</h3>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body table-responsive p-0">
                            <table class="table table-hover">
                                <thead>
                                <tr>
                                    <th>{{ $t('title_international') }}</th>
                                    <th>{{ $t('amount') }}</th>
                                    <th>{{ $t('currency') }}</th>
                                    <th>{{ $t('date') }}</th>
                                    <th>{{ $t('download_sales_report') }}</th>
                                    <th>{{ $t('invoice_payed') }}</th>
                                    <th>{{ $t('invoice_upload') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="report in reports" :key="report.report.id" style="max-height: 100px;">
                                    <td>{{ report.movie.title_international }}</td>
                                    <td>{{ report.report.amount }}</td>
                                    <td>{{ report.report.currency }}</td>
                                    <td>{{ report.report.report_date }}</td>
                                    <td>
                                        <a href="#" @click="downloadReport(report.report.id)">
                                            <i class="fa fa-download blue"></i>
                                        </a>
                                    </td>
                                    <td>
                                        <span :inner-html.prop="report.report.payed | yesno"/>
                                    </td>
                                    <td>
                                        <VueFileAgent
                                            v-model="report.report.invoiceFileFormat"
                                            :multiple="false"
                                            :maxSize="'10MB'"
                                            :compact="true"
                                            :theme="'list'"
                                            maxFiles="1"
                                            :deletable="true"
                                            :uploadUrl="$baseUrl + '/movie-reports/' + report.report.id + '/invoice'"
                                            :uploadHeaders="$axios.defaults.headers.common"
                                            @delete="deleteInvoice"
                                            @upload="onUploadInvoice"
                                            :helpText="$t('drag_and_drop')"
                                        />
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>
                        <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import movies from "../services/api/movies";

export default {
    name: "MoviesReports",
    data() {
        return {
            reports: [],
            residenceCertificateUploadUrl: null,
            hasCertificate: true
        }
    },
    methods: {
        loadReports() {
            movies.getReports().then(({data}) => (this.reports = data.data));
        },
        async downloadReport(reportId) {
            this.$Progress.start();
            try {
                let response = await movies.getReportFile(reportId)

                let filename = ''
                let disposition = response.headers['content-disposition']
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
                    let matches = filenameRegex.exec(disposition)
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '')
                    }
                }
                let fileDownload = require('js-file-download');
                fileDownload(response.data, filename);
            } catch (err) {
                this.$console.log(err)
            }
            this.$Progress.finish();
        },
        async deleteInvoice(fileRecord) {
            this.$Progress.start()
            try {
                let response = await movies.deleteInvoice(fileRecord.id);
                this.$Progress.stop();
            } catch (e) {
                console.log(e)
                this.$Progress.fail();
                await Toast.fire({
                    icon: 'error',
                    title: 'Some error occured! Please try again'
                });
            }

        },
        onUploadInvoice(response) {
            this.loadReports()
        },
        async onUploadResidenceCertificate() {
            this.hasCertificate = true
            await Toast.fire({
                icon: 'success',
                title: this.$t('')
            });
        },
    },
    created() {
        this.$Progress.start();
        this.loadReports();
        this.residenceCertificateUploadUrl = window.baseUrl + '/residence-certificate'
        axios.get("/api/v1/rights-owners/profile")
            .then((response) => {
                this.hasCertificate = response.data.data.hasCertificateCurrentYear
            });
        this.$Progress.finish();
    },
}
</script>

<style lang="scss">
table {
    .vue-file-agent.file-input-wrapper,
    .file-preview-wrapper.grid-box-item.grid-block.file-preview-new,
    .grid-block-wrapper .grid-block .file-preview,
    .grid-block-wrapper .grid-block .file-preview span {
        height: 65px;
    }
}
</style>
